export default "__VITE_ASSET__kd$IJR4C__"